export const UNKNOWN_ERROR = 'Unknown error'
export const AMOUNT_TOO_LOW = 'Amount is too low'
export const UNSUPPORTED_TOKEN = 'Token is not supported'
